import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import convert from '../../helpers/convert'
import {
  LinkIcon
} from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdFossilFinanceGrade extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func,
    fieldName: PropTypes.string.isRequired,
    mobile: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
    //
    let fieldName = props.fieldName
    if (props.fieldName === 'fossil_bank_score') {
      fieldName = 'grade_fossil_bank'
    }
    if (props.fieldName === 'fossil_insure_score') {
      fieldName = 'grade_fossil_insure'
    }
    const val = props.shareclass[fieldName]

    let financeRange = 'undefined'
    let financeRangeName = 'err'
    switch (convert.int(val)) {
      case 1:
        financeRange = 'low'
        financeRangeName = 'A'
        break
      case 2:
        financeRange = 'below'
        financeRangeName = 'B'
        break
      case 3:
        financeRange = 'above'
        financeRangeName = 'C'
        break
      case 4:
        financeRange = 'high'
        financeRangeName = 'D'
        break
      case 5:
        financeRange = 'extreme'
        financeRangeName = 'F'
        break
      case -1:
        break
      default:
        break
    }
    //
    this.state = {
      financeRange,
      financeRangeName
    }
  }
  //
  render() {
    return <td
      styleName={'col' + (this.props.mobile ? '-right' : '')}
      onClick={this.props.clickShareclass(this.props.shareclass, 'fossil-finance-insurance') }
    >
      <div styleName='score-wrapper-w-tail' >
        <span styleName={'footrange-' + this.state.financeRange}>
          <LinkIcon faclass='fa-circle'/>
          &nbsp;
          <span styleName='grade-font'>
            {this.state.financeRangeName}
          </span>
        </span>
        &nbsp;
      </div>
    </td>
  }
}